import { styled } from '@mui/material/styles';

export const Container = styled('div')({});

export const Inner = styled('div')(({ theme }) => ({
  border: `solid 1px ${theme.palette.divider}`,
  borderRadius: 5,
}));

export const TabHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '0 10px',
  backgroundColor: theme.palette.grey[100],
  borderBottom: `solid 1px ${theme.palette.divider}`,
}));

export const TabContent = styled('div')({
  position: 'relative',
  height: 392,
  overflow: 'auto',
});

export const TabGroupItem = styled('div')({
  display: 'flex',
  alignItems: 'center',
  marginRight: 50,
});

export const TabItem = styled('div')(({ theme }) => ({
  fontSize: 14,
  lineHeight: '21px',
  padding: '10px 20px',
  margin: '0 10px 0px',
  color: theme.palette.text.primary,
  fontFamily: 'AvenirNext-DemiBold',
  cursor: 'pointer',
  borderBottom: '3px solid transparent',
  '&.active': {
    borderBottom: `3px solid ${theme.palette.primary.main}`,
  },
}));

export const TabIcon = styled('div')(({ theme }) => ({
  fontSize: 18,
  padding: '10px 5px',
  margin: '0 5px 0px',
  cursor: 'pointer',
  borderBottom: '3px solid transparent',
  '&.active': {
    borderBottom: `3px solid ${theme.palette.primary.main}`,
  },
}));

export const Control = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'center',
  margin: '10px 0 5px',
}));

export default {
  controlButton: {
    width: '150px',
    padding: '0px',
  },
  loadingStyle: {
    position: 'absolute',
    left: '0px',
    top: '0px',
    right: '0px',
    bottom: '0px',
    margin: 'auto',
  },
};
